// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1aj-s","text":"SelectPayment_text__s3nL_","title":"SelectPayment_title__2HqPp","btn":"SelectPayment_btn__2mxwj"};